import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private footerSubject$ = new BehaviorSubject<any>(null);
  public footer$ = this.footerSubject$.asObservable();

  constructor(private contentful: ContentfulService) {}

  footerData: any;

  getFooterData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.footer,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.footerData = mod.filter(x => x?.fields['id'] == PageId.psFooter);
        const footerData = this.footerData[0].fields;
        if (footerData) {
          this.footerSubject$.next(footerData);
        }
      });
  }
}
